<template>
  <div class="to-do-collapse-list">
    <div
      class="title"
      @click="$_collapseToggle()"
    >
      {{ listTitle }} {{ subTaskList.length }}
      <i
        v-if="collapseActive"
        class="icon-chevron-up"
      />
      <i
        v-else
        class="icon-chevron-down"
      />
    </div>
    <slide-up-down
      :active="collapseActive"
      :duration="500"
      class="list"
    >
      <slot />
    </slide-up-down>
  </div>
</template>
<script>
import taskService from "@/service/api/v1/task";
export default {
  name: "ToDoCollapseList",
  props: {
    listItemNum: {
      type: Number,
      default: 0,
    },
    listTitle: {
      type: String,
      default: "",
    },
    subTaskList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    collapseActive: true,
  }),
  methods: {
    $_collapseToggle() {
      this.collapseActive = !this.collapseActive;
    },
    async $_subTaskCompleteClick(subTask) {
      let subTaskId = subTask.id;
      if (!subTask.done_at) {
        const res = await taskService.subTaskDone(subTaskId);
        subTask.done_at = res.done_at;
        this.$_subTaskPopupOpen(subTaskId);
      } else {
        await taskService.subTaskUnDone(subTaskId);
        subTask.done_at = null;
      }
      this.$_searchTask();
      this.$_getProcessingTask(this.allTaskContent);
      this.$_getAuditedTask(this.allTaskContent);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/to-do-collapse-list";
</style>